
            const data = {"name":"minus-circle","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M30 1a29 29 0 1029 29A29 29 0 0030 1zm5.8 30.45H24.2v-2.9h11.6z\" _fill=\"#171614\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                